class CustomerGroupController extends AbstractEntityEditController
	@register()
	@inject 'customerGroup',
		'CustomerGroupRepository'
		'ConfigurationService'

	initialize: ->
		@mainCrud.entityType = 'general.customer.group'
		@mainCrud.entityTitle = 'wbo.customer.group.create.new'

		if @customerGroup.id?
			@mainCrud.entityTitle = @customerGroup.name
			@mainCrud.isNewEntity = false

		@areLoyaltyPointsThresholdsEnabled = @ConfigurationService.isEnabled(
			'Backoffice.Setting.MoveCustomerInGroupsByPoints.Enabled'
		)

	save: ->
		@CustomerGroupRepository
			.save @customerGroup, @mainCrud.isNewEntity
			.then (response) =>
				@afterSave response
			.catch (response) =>
				@handleErrors response

	delete: ->
		@deleteEntity @CustomerGroupRepository, @customerGroup

	onLoyaltyPointsThresholdChanged: ->
		isValid = @customerGroup.lower_loyalty_points_threshold <= @customerGroup.upper_loyalty_points_threshold
		@mainCrud.parent_form.lower_loyalty_points_threshold.$setValidity('rangeMin', isValid)
		@mainCrud.parent_form.upper_loyalty_points_threshold.$setValidity('rangeMax', isValid)
